type RuntimeEnv = {
    REACT_APP_AUTH_BACKEND_API_SCOPE: string;
    REACT_APP_AUTH_CLIENT_ID: string;
    REACT_APP_AUTH_TENANT_ID: string;
    REACT_APP_AUTH_REDIRECT_URL: string;
    REACT_APP_APPINSIGHTS_CONNECTION_STRING: string;
    REACT_APP_API_URL: string;
    REACT_APP_ENV: string;
    REACT_APP_CONTACTS: string;
    REACT_APP_MANUALS: string;
    REACT_APP_RELEASE_NOTES: string;
};

const w = window as unknown as { _env_?: Partial<RuntimeEnv> };

const fromRuntime = (key: keyof RuntimeEnv): string =>
    w._env_?.[key] ?? process.env[key] ?? '';

export const env: RuntimeEnv = {
    REACT_APP_AUTH_BACKEND_API_SCOPE: fromRuntime('REACT_APP_AUTH_BACKEND_API_SCOPE'),
    REACT_APP_AUTH_CLIENT_ID: fromRuntime('REACT_APP_AUTH_CLIENT_ID'),
    REACT_APP_AUTH_TENANT_ID: fromRuntime('REACT_APP_AUTH_TENANT_ID'),
    REACT_APP_AUTH_REDIRECT_URL: fromRuntime('REACT_APP_AUTH_REDIRECT_URL'),
    REACT_APP_APPINSIGHTS_CONNECTION_STRING: fromRuntime('REACT_APP_APPINSIGHTS_CONNECTION_STRING'),
    REACT_APP_API_URL: fromRuntime('REACT_APP_API_URL'),
    REACT_APP_ENV: fromRuntime('REACT_APP_ENV'),
    REACT_APP_CONTACTS: fromRuntime('REACT_APP_CONTACTS'),
    REACT_APP_MANUALS: fromRuntime('REACT_APP_MANUALS'),
    REACT_APP_RELEASE_NOTES: fromRuntime('REACT_APP_RELEASE_NOTES'),
};